<template>
  <div class="maintable">
    <div class="top-box jzxx mt20">
      <h2>不动产登记“互联网+金融”主债权合同及抵押合同表</h2>
    </div>
    <div class="clearfloat second-box">
      <p class="fr jzxr">单位:平方米、万元</p>
    </div>
    <table class="mt20 tableBolder" border="0" cellspacing="0" cellpadding="0">
      <tr>
        <td colspan="11">主债权合同编号：{{ infoData.zzqhtbh }}</td>
        <td colspan="11">抵押合同编号：{{ infoData.dyhtbh }}</td>
      </tr>
      <tr>
        <td rowspan="6" class="lh20">合同当事人</td>
        <td colspan="4">抵押权人</td>
        <td colspan="17">{{ infoData.dyqr }}</td>
      </tr>
      <tr>
        <td colspan="4">证件种类</td>
        <td colspan="6">{{ infoData.zjzl }}</td>
        <td colspan="3">证件号</td>
        <td colspan="8">{{ infoData.zjh }}</td>
      </tr>
      <tr>
        <td colspan="4">抵押人</td>
        <td colspan="17">{{ infoData.dyr }}</td>
      </tr>
      <tr>
        <td colspan="4">证件种类</td>
        <td colspan="6">{{ infoData.dyrzjzl }}</td>
        <td colspan="3">证件号</td>
        <td colspan="8">{{ infoData.dyrzjh }}</td>
      </tr>
      <tr>
        <td colspan="4">借款人</td>
        <td colspan="17">{{ infoData.jkr }}</td>
      </tr>
      <tr>
        <td colspan="4">证件种类</td>
        <td colspan="6">{{ infoData.jkrzjzl }}</td>
        <td colspan="3">证件号</td>
        <td colspan="8">{{ infoData.jkrzjh }}</td>
      </tr>
      <tr>
        <td rowspan="2" class="lh20">债权情况</td>
        <td colspan="4">债权数额</td>
        <td colspan="4">{{ infoData.bdbzzqse }}</td>
        <td colspan="5">担保范围</td>
        <td colspan="8">详见合同</td>
      </tr>
      <tr class="guaranteeMethod">
        <td colspan="4">担保方式</td>
        <td colspan="4">
          一般抵押(<span class="right">{{ infoData.dbfs === '1' ? '√' : '' }}</span
          >)<br />最高额抵押(<span class="right">{{ infoData.dbfs === '2' ? '√' : '' }}</span
          >)
        </td>
        <td colspan="5">债务履行期限（债务确定时间）</td>
        <td colspan="8">
          自 {{ infoData.zwlxqssj }}起<br />至 {{ infoData.zwlxjssj }}止
          <!-- 自<span class="date">XXXX</span>年<span class="date">XX</span>月<span class="date">XX</span>日起<br /> -->
        </td>
      </tr>
      <tr>
        <td rowspan="5" class="lh20">抵押物情况</td>
        <td colspan="6">不动产坐落</td>
        <td colspan="15">{{ infoData.zl }}</td>
      </tr>
      <tr>
        <td colspan="6">不动产单元号</td>
        <td colspan="15">{{ infoData.bdcdyh }}</td>
      </tr>
      <tr>
        <td colspan="6">不动产权证号</td>
        <td colspan="15">{{ infoData.bdcqzh }}</td>
      </tr>
      <tr>
        <td colspan="6">土地/房屋抵押面积</td>
        <td colspan="15">{{ infoData.tdfwdymj }}</td>
      </tr>
      <tr>
        <td colspan="6">抵押物价值</td>
        <td colspan="4">{{ infoData.dywjz }}</td>
        <td colspan="4">被担保债权数额(最高债权数额)</td>
        <td colspan="7">{{ infoData.bdbzzqse }}</td>
      </tr>
      <tr>
        <td class="lh20">附记</td>
        <td colspan="21">{{ infoData.fj }}</td>
      </tr>
      <tr>
        <td colspan="22" class="signature">
          <p class="letter">
            合同当事人已依法确认上述内容与主债权合同及抵押合同内容一致，并对其真实性负责。如有不实，合同当事人愿承担法律责任。
          </p>
          <p class="mt20"><span>抵押权人（签章）：</span><span>抵押人（签章）：</span><span>借款人（签章）：</span></p>
          <p><span>代理人：</span><span>代理人：</span><span>代理人：</span></p>
          <p>
            <span><i class="space"></i>年<i class="space"></i>月<i class="space"></i>日</span>
            <span><i class="space"></i>年<i class="space"></i>月<i class="space"></i>日</span>
            <span><i class="space"></i>年<i class="space"></i>月<i class="space"></i>日</span>
          </p>
        </td>
      </tr>
    </table>
    <div class="footer-box mt20">
      <div>
        <p class="letter">
          注：本表式样经{{ selectedShiTitle }}自然资源局和{{
            selectedShiTitle
          }}银保监分局共同审定，与主债权合同及抵押合同具有同等法律效力。在办理抵押登记时由金融机构向不动产登记部门推送。
        </p>
      </div>
    </div>
    <div class="main-footer text-center">
      <el-button type="primary" @click="prev()">上一步</el-button>
      <el-button type="primary" @click="printDyht">下载PDF</el-button>
      <el-button type="primary" @click="next()">下一步</el-button>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { getQueryDyhtxx } from '@iebdc/api/mortgage-contract';
import { printDyht } from '@/pages/iebdc/api/my-query.js';
export default {
  data() {
    return {
      infoData: {}, //合同信息
    };
  },
  computed: {
    // 下一步跳转所需数据
    ...mapState('wysq-step', ['nextItem']),
    ...mapState('dashboard', ['selectedShiTitle']),
    ...mapState('wysq-data', ['flowInfoIng']),
  },
  mounted() {
    this.targetToStep('抵押合同');
    this.getQueryDyhtxx(); //获取抵押合同信息
  },
  methods: {
    // 更新流程信息
    ...mapMutations('wysq-data', ['setFlowInfoIng']),
    // 跳转到下一页面
    ...mapMutations('wysq-step', ['targetToStep']),
    // 跳转到上一页面
    prev() {
      this.targetToStep('填写申请表');
      this.$router.push({
        name: 'applicantTable',
        params: { ywh: this.flowInfoIng.wwywh },
      });
    },
    // 跳转到下一页面,需先校验当前页面数据状态 TODO
    next() {
      this.targetToStep('抵押合同');
      this.$router.push({
        name: this.nextItem.name,
      });
    },
    //获取抵押合同信息
    async getQueryDyhtxx() {
      let res = await getQueryDyhtxx({ wwywh: this.flowInfoIng.wwywh, qymc: this.selectedShiTitle });
      if (res) {
        this.infoData = res;
        console.log(this.infoData);
      } else {
        this.$message.error('获取数据失败');
      }
    },
    //打印抵押合同
    printDyht() {
      printDyht({ wwywh: this.flowInfoIng.wwywh, qymc: this.selectedShiTitle }).then((res) => {
        if (res.data && res.success) {
          window.open(res.data);
        } else {
          this.$message.warning('下载失败!');
        }
      });
    },
  },
};
</script>
<style scoped lang="scss">
table,
tr,
td {
  border: 0px;
  text-align: left;
  padding: 8px;
  font-size: 14px;
}

.maintable {
  width: 860px;
  border: 0px;
  margin: 0 auto;
  position: relative;
}

.lh20 {
  line-height: 20px;
}

.clearfloat:after {
  display: block;
  clear: both;
  content: '';
  visibility: hidden;
  height: 0;
}

.clearfloat {
  zoom: 1;
}

.fr {
  float: right;
}

.top-box {
  height: 40px;
  h2 {
    line-height: 40px;
  }
}

.mt20 {
  margin-top: 20px;
}

.second-box p {
  line-height: 20px;
}

.jzxx {
  text-align: center;
}

.jzxr {
  text-align: right;
}

.footer-box p {
  line-height: 18px;
}

.tableBolder {
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;
  tr {
    height: 40px;
    td {
      border: 1px solid #000;
      padding: 8px;
    }
  }
  tr.guaranteeMethod {
    height: 60px;
    line-height: 25px;
    .date {
      width: 48px;
      display: inline-block;
      border-bottom: 1px solid #000;
      vertical-align: bottom;
      text-align: center;
    }
  }
}
.space {
  width: 30px;
  display: inline-block;
}

.letter {
  text-indent: 26px;
}

.signature p {
  line-height: 25px;
  span {
    width: 32%;
    display: inline-block;
  }
}
.right {
  width: 20px;
  display: inline-block;
  text-align: center;
}
</style>
